export const filterObjectForUpdateTracking = (filteredValues) =>
  Object.entries(filteredValues).reduce((res, [key, value]) => {
    if (Array.isArray(value) && value.length) {
      const filterValue = value
        .map((item) => {
          if (typeof item === "object" && Object.keys(item).length > 1) {
            return filterObjectForUpdateTracking(item);
          }
          return item;
        })
        .filter((item) => {
          if (
            item &&
            typeof item === "object" &&
            Object.keys(item).length > 1
          ) {
            return item;
          }
          if (typeof item !== "object") return item;
        });

      if (filterValue.length) {
        return { ...res, [key]: filterValue };
      }
    } else if (value && typeof value === "object") {
      if (Object.keys(value).length > 1) {
        const filterValue = filterObjectForUpdateTracking(value);
        if (Object.keys(filterValue).length > 1) {
          return { ...res, [key]: filterValue };
        }
      }
    } else {
      if (value !== "" && value !== null) {
        return { ...res, [key]: value };
      }
    }
    return res;
  }, {});
